import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BanknoteIcon, BarChart3Icon, CloudIcon, BookOpenIcon, LeafIcon, ShieldCheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Members() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  const {
    t
  } = useLanguage();
  const members = [{
    name: 'TechBridge Solutions',
    industry: 'Fintech',
    descKey: 'members.c1.desc',
    icon: BanknoteIcon
  }, {
    name: 'DataFlow Analytics',
    industry: 'Big Data',
    descKey: 'members.c2.desc',
    icon: BarChart3Icon
  }, {
    name: 'CloudNest',
    industry: 'Cloud Infrastructure',
    descKey: 'members.c3.desc',
    icon: CloudIcon
  }, {
    name: 'EduTech Hub',
    industry: 'EdTech',
    descKey: 'members.c4.desc',
    icon: BookOpenIcon
  }, {
    name: 'GreenCode',
    industry: 'GreenTech',
    descKey: 'members.c5.desc',
    icon: LeafIcon
  }, {
    name: 'CyberShield',
    industry: 'Cybersecurity',
    descKey: 'members.c6.desc',
    icon: ShieldCheckIcon
  }];
  return <section id="members" ref={ref} className="relative w-full overflow-hidden px-4 py-16 sm:py-24" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-266">
      <div className="relative z-10 mx-auto max-w-7xl" data-id="element-267">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.4,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} className="mb-12 sm:mb-16 text-center" data-id="element-268">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-269">
            {t('members.title')}
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-270">
            {t('members.desc')}
          </p>
        </motion.div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-271">
          {members.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.35,
          delay: 0.05 + index * 0.05,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} data-id="element-272">
              <div className="h-full rounded-3xl border p-6 sm:p-8 flex flex-col relative transition-all hover:shadow-md" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-secondary)'
          }} data-id="element-273">
                <div className="flex items-center gap-4 mb-5" data-id="element-274">
                  <div className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'var(--bg-tertiary)'
              }} data-id="element-275">
                    <member.icon className="w-6 h-6" style={{
                  color: 'var(--accent)'
                }} data-id="element-276" />
                  </div>
                  <div data-id="element-277">
                    <h3 className="text-lg font-bold leading-tight mb-1" style={{
                  color: 'var(--text-primary)'
                }} data-id="element-278">
                      {member.name}
                    </h3>
                    <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium" style={{
                  backgroundColor: 'var(--bg-tertiary)',
                  color: 'var(--text-secondary)'
                }} data-id="element-279">
                      {member.industry}
                    </span>
                  </div>
                </div>
                <p className="text-sm sm:text-base leading-relaxed" style={{
              color: 'var(--text-secondary)'
            }} data-id="element-280">
                  {t(member.descKey)}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}